'use client';

import { Box, Typography, Paper, Stack } from '@mui/material';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import PhoneOutlinedIcon from '@mui/icons-material/PhoneOutlined';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import { useTranslations } from 'next-intl';

const ContactInfo = () => {
    const t = useTranslations('ContactPage.ContactInfo');
    return (
        <Stack spacing={4}>
            {/* Contact Details */}
            <Paper
                elevation={0}
                sx={{
                    p: 4,
                    borderRadius: '16px',
                    border: '1px solid #e2e8f0',
                    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05)'
                }}
            >
                <Typography variant="h6" sx={{ fontWeight: 800, color: '#1e293b', mb: 4 }}>
                    {t('title')}
                </Typography>

                <Stack spacing={4}>
                    <Box sx={{ display: 'flex', gap: 2 }}>
                        <EmailOutlinedIcon sx={{ color: '#F15859', fontSize: '1.5rem', mt: 0.5 }} />
                        <Box>
                            <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#1e293b' }}>
                                {t('email_title')}
                            </Typography>
                            <Typography variant="body2" sx={{ color: '#64748b' }}>
                                contact@airxpress.jp
                            </Typography>
                        </Box>
                    </Box>

                    <Box sx={{ display: 'flex', gap: 2 }}>
                        <PhoneOutlinedIcon sx={{ color: '#F15859', fontSize: '1.5rem', mt: 0.5 }} />
                        <Box>
                            <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#1e293b' }}>
                                {t('phone_title')}
                            </Typography>
                            <Typography variant="body2" sx={{ color: '#64748b' }}>
                                06-6123-1071（平日 9:00-18:00）
                            </Typography>
                        </Box>
                    </Box>

                    <Box sx={{ display: 'flex', gap: 2 }}>
                        <LocationOnOutlinedIcon sx={{ color: '#F15859', fontSize: '1.5rem', mt: 0.5 }} />
                        <Box>
                            <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#1e293b' }}>
                                {t('head_office_title')}
                            </Typography>
                            <Typography variant="body2" sx={{ color: '#64748b' }}>
                                〒530-0017
                                <br />
                                大阪府大阪市北区角田町8-47
                                <br />
                                阪急グランドビル26階
                            </Typography>
                        </Box>
                    </Box>
                </Stack>
            </Paper>

            {/* Business Hours */}
            <Paper
                elevation={0}
                sx={{
                    p: 4,
                    borderRadius: '16px',
                    border: '1px solid #e2e8f0',
                    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05)'
                }}
            >
                <Typography variant="h6" sx={{ fontWeight: 800, color: '#1e293b', mb: 3 }}>
                    {t('business_hours_title')}
                </Typography>

                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1.5 }}>
                    <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#475569' }}>
                        {t('weekday')}
                    </Typography>
                    <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#1e293b' }}>
                        {t('weekday_hours')}
                    </Typography>
                </Box>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 3 }}>
                    <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#475569' }}>
                        {t('weekend')}
                    </Typography>
                    <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#1e293b' }}>
                        {t('weekend_hours')}
                    </Typography>
                </Box>

                <Typography variant="caption" sx={{ color: '#94a3b8', display: 'block' }}>
                    {t('note')}
                </Typography>
            </Paper>
        </Stack>
    );
};

export default ContactInfo;
